<template>
  <div class="container">
    <nav-bar>常用行程</nav-bar>
    <div class="title">{{ lineName }}</div>
    <div class="list">
      <state-loading v-if="isLoading" />
      <template v-else>
        <div
          v-for="(item, index) in list"
          :key="index"
          class="item"
          @click="onCall(item)"
        >
          <div class="item-stop">
            <img src="../../assets/img-v2/ic_on.png" class="item-stop-icon" />
            <span class="item-stop-name">{{ item.onName }}</span>
          </div>
          <div class="item-stop">
            <img src="../../assets/img-v2/ic_off.png" class="item-stop-icon" />
            <span class="item-stop-name">{{ item.offName }}</span>
          </div>

          <div class="item-btn">一键呼叫</div>
        </div>
      </template>
    </div>
    <div class="btn" @click="onGoDirectCall">一键呼叫设置</div>
  </div>
</template>

<script>
import StateLoading from '../../components/state-loading'
import NavBar from '../../components/nav-bar'
import { getCallList } from './api/index'
import { startOrder, showToast } from './service'
import { mapMutations } from 'vuex'

export default {
  components: {
    StateLoading,
    NavBar
  },
  data() {
    return {
      isLoading: false,
      ordering: false,
      list: []
    }
  },
  computed: {
    baseLineId() {
      return this.$route.query.baseLineId
    },
    lineName() {
      return this.$route.query.lineName || ''
    }
  },
  watch: {
    ordering(val) {
      showToast('下单中，请稍候', val, this)
    }
  },
  activated() {
    this.reuestCallList()
  },
  methods: {
    ...mapMutations({
      setShowCall: 'config/setShowCall'
    }),
    reuestCallList() {
      const userId = this.$UserService.getUserId()
      if (!userId) return
      const cityId = this.$AppService.getCityId()
      this.isLoading = true
      return getCallList({
        userId,
        cityId,
        baseLineId: this.baseLineId
      })
        .then(res => {
          this.list = res || []
        })
        .catch(err => {
          this.$toast(err.msg || '未知异常')
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    onCall(info) {
      if (this.ordering) return

      const { baseLineId, onId, onName, offId, offName } = info
      this.ordering = true
      startOrder(
        {
          baseLineId,
          onStopId: onId,
          onStopName: onName,
          offStopId: offId,
          offStopName: offName
        },
        this
      )
        .then(() => {
          this.setShowCall(false)
          this.$OrderService.turnToOrderPay(
            { from: 'Home' },
            { ticketInfoId: this.$AppService.getTicketInfoId() }
          )
        })
        .catch(res => {
          this.$cheToast({
            type: 'fail',
            text: res.msg || res.errmsg,
            timeout: 3000
          }).show()
        })
        .finally(() => {
          this.ordering = false
        })
    },
    onGoDirectCall() {
      this.$router.push({
        name: 'directCall'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  height: 100%;
  background: #f7f7f7;
  -webkit-overflow-scrolling: touch;
}
.title {
  height: 50px;
  font-size: 18px;
  font-weight: 500;
  text-align: center;
  background: #fff;
  line-height: 50px;
}
.list {
  padding: 10px 0;
  max-height: calc(100% - 200px);
  overflow-y: scroll;
}
.item {
  position: relative;
  background: #fff;
  padding: 10px 100px 10px 20px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  &-stop {
    padding-bottom: 5px;
    display: flex;
    align-items: center;
    &-icon {
      width: 20px;
      height: 20px;
      min-width: 20px;
      margin-right: 6px;
    }
    &-name {
      max-width: calc(100% - 35px);
      display: inline-block;
      font-size: 14px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  &-btn {
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    background: #ff4d4f;
    color: #fff;
    position: absolute;
    right: 15px;
  }
}
.btn {
  position: fixed;
  bottom: 40px;
  font-size: 16px;
  font-weight: 500;
  color: #1792ff;
  text-align: center;
  padding: 10px;
  left: 50%;
  transform: translateX(-50%);
}
</style>
